import React, { useState } from 'react';
import { withTheme } from 'styled-components';
import Helmet from 'react-helmet';
import { withRouter } from 'react-router-dom';
import { useQuery } from 'react-query';
import * as API from 'api';

import { muiTheme } from 'styles/theme';
import { withStyles } from '@material-ui/core/styles';
import MuiCssBaseline from '@material-ui/core/CssBaseline';
import MuiHidden from '@material-ui/core/Hidden';
import MuiTypography from '@material-ui/core/Typography';
import MuiLink from '@material-ui/core/Link';
import MuiBreadcrumbs from '@material-ui/core/Breadcrumbs';

import Header from 'components/Header';
import HeaderActAs from 'components/HeaderActAs';
import NavSidebar from 'components/NavSidebar';

import { dashCaseToTitle } from 'utils/helpers';

const FOOTER_HEIGHT = '4.5rem';
const DRAWER_WIDTH = 225;

// https://github.com/mui-org/material-ui/blob/master/docs/src/pages/premium-themes/paperbase/Paperbase.js

const styles = {
  root: {},
  sidebar: {
    width: DRAWER_WIDTH,
    height: '100vh',
    top: '-48px',
    paddingTop: '48px',
    position: 'relative',
  },
  drawer: {
    [muiTheme.breakpoints.up('md')]: {
      width: DRAWER_WIDTH,
      flexShrink: 0,
      position: 'fixed',
    },
  },
  app: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    [muiTheme.breakpoints.up('md')]: {
      paddingLeft: DRAWER_WIDTH,
    },
  },
  main: {
    flex: 1,
    padding: muiTheme.spacing(2, 2),
    background: '#eaeff1',
  },
  breadcrumb: {
    fontSize: 'small',
    paddingBottom: muiTheme.spacing(1),
  },
  footer: {
    padding: muiTheme.spacing(1),
    background: '#eaeff1',
  },
};

const Users = API.Users();

const ViewWrapper = ({ children, theme, ...props }) => {
  const { classes, match } = props;

  const [mobileOpen, setMobileOpen] = useState(false);

  const pathParts = match.path
    .substr(1)
    .split('/')
    .filter(p => p.indexOf(':') === -1);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const { data: meData } = useQuery(['me'], () => Users.getMe());

  return (
    <>
      <Helmet>
        <style>
          {`
            body {
              background-color: ${theme.colors.black100};
            }
          `}
        </style>
      </Helmet>

      <div className={classes.root}>
        <MuiCssBaseline />
        {meData && Number(meData.id) != Number(meData.auth0RealUserId) && <HeaderActAs meData={meData} />}
        <Header onDrawerToggle={handleDrawerToggle} />
        <div
          style={{
            display: 'flex',
            width: '100%',
            height: 'calc(100vh - 48px)',
          }}>
          <nav className={classes.drawer}>
            <MuiHidden mdUp implementation="js">
              <NavSidebar
                PaperProps={{ classes: { root: classes.sidebar } }}
                variant="temporary"
                open={mobileOpen}
                onClose={handleDrawerToggle}
              />
            </MuiHidden>
            <MuiHidden smDown implementation="css">
              <NavSidebar PaperProps={{ classes: { root: classes.sidebar } }} />
            </MuiHidden>
          </nav>
          <div className={classes.app}>
            <main className={classes.main}>
              <MuiBreadcrumbs className={classes.breadcrumb}>
                {pathParts.map((part, i) =>
                  i < pathParts.length - 1 ? (
                    <MuiLink key={i} color="inherit" href={`/${pathParts.slice(0, i + 1).join('/')}`}>
                      {dashCaseToTitle(part)}
                    </MuiLink>
                  ) : (
                    <span key={i}>{dashCaseToTitle(part)}</span>
                  )
                )}
              </MuiBreadcrumbs>
              {children}
            </main>
            <footer className={classes.footer}>
              <MuiTypography variant="body2" color="textSecondary" align="center">
                {`© Copyright ${new Date().getFullYear()} · `}
                <MuiLink color="inherit" href="https://qanda.la/">
                  Q&A Media, Inc
                </MuiLink>
              </MuiTypography>
            </footer>
          </div>
        </div>
      </div>
    </>
  );
};

export default withStyles(styles)(withRouter(withTheme(ViewWrapper)));
